var Plugin = require("common/Plugin");
var ConnectionController = require("connect/ConnectionController");

var ConnectionPlugin = function() {
    var self = this;

    this.start = function() {
        self.registerController(new ConnectionController());
    };
};

ConnectionPlugin.prototype = Plugin;

module.exports = ConnectionPlugin;


//////////////////
// WEBPACK FOOTER
// ./connect/ConnectionPlugin.js
// module id = 28
// module chunks = 0 3